import styled from "styled-components";

export const TableHeaderWrapper = styled.div`
  display: grid;
  grid-template-areas: "PurchasedDate Description TotalCost PaymentMethod Receipt CancelOrRefund";
  grid-template-columns: 90px 120px 70px 105px auto auto;
  /* border: 1px solid black; */
  column-gap: 10px;
  font-size: 13px;
  // padding: 5px;
  padding-top: 20px;
  padding-bottom: 20px;
  /* border-top: 1px solid #eee; */
  border-bottom: 1px solid #eee;
  @media screen and (max-width: 440px){
    grid-template-columns: 52px 60px 40px 50px auto;
  }
  @media screen and (max-width: 320px){
    grid-template-columns: 35px 60px 35px 35px auto;
  }
`;

export const PurchasedDate = styled.div`
  /* border: 1px solid black; */
  width: 90px;
  @media screen and (max-width: 440px){
    width :52px;
  }
  @media screen and (max-width : 320px){
    width : 35px;
  }
`;
export const Description = styled.div`
  /* border: 1px solid black; */
  /* padding: 0 6rem 0 6rem; */
  width : 120px;
  @media screen and (max-width : 440px) {
    width : 60px;
  }
  @media screen and (max-width : 320px){
    width : 60px;
  }
 
`;
export const TotalCost = styled.div`
/* padding: 0 0 0 1rem; */
  /* border: 1px solid black; */
  width : 70px;
  @media screen and (max-width : 440px) {
    width : 40px;
  }
  @media screen and (max-width : 320px){
    width : 35px;
  }
`;
export const PaymentMethod = styled.div`
  /* border: 1px solid black; */
  width : 105px;
  @media screen and (max-width : 440px) {
    width : 50px;
  }
  @media screen and (max-width : 320px){
    width : 35px;
  }
`;export const Status = styled.div`
/* border: 1px solid black; */
width : 105px;
@media screen and (max-width : 440px) {
  width : 50px;
}
@media screen and (max-width : 320px){
  width : 35px;
}
`;
export const Receipt = styled.div`
  /* border: 1px solid black; */
`;

export const CancelOrRefund = styled.div`
  /* border: 1px solid black; */
`;
